// extracted by mini-css-extract-plugin
module.exports = {"changeLogWrapper":"ChangeLogContent_changeLogWrapper__FWMZO","image":"ChangeLogContent_image__pmK41"};